import i18n from '@/f1/service/i18n';

import KO from './i18n.ko.v1';
import EN from './i18n.en.v1';
import JP from './i18n.jp.v1';

export default i18n({ EN, KO, JP });